import React, { Suspense, useState } from 'react';
import dynamic from 'next/dynamic';
import { getPageStaticProps } from 'lib/dato-request';
import NewHome from 'pages';

const Teachers = ({ data }) => {
    return (
        <NewHome data={data} location='teachers'/>
    );
};

export async function getStaticProps() {
    return getPageStaticProps('Parents');
}

export default Teachers;
